import React from "react";
import { useFormContext } from "react-hook-form";
import {
  MIN_POLICY_CHARS,
  MAX_POLICY_CHARS,
} from "./constants/validation";

export default function StorePoliciesTab() {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const rpErr  = errors?.policies?.returnPolicy;
  const tosErr = errors?.policies?.termsOfSale;

  const base =
    "mt-2 w-full rounded border p-2 focus:outline-none focus:ring-2 focus:ring-indigo-500";

  return (
    <section className="space-y-6">
      {/* Return Policy --------------------------------------------------- */}
      <div>
        <label className="block font-medium">
          Return Policy <span className="text-red-500">*</span>
        </label>
        <textarea
          {...register("policies.returnPolicy")}
          rows={4}
          minLength={MIN_POLICY_CHARS}
          maxLength={MAX_POLICY_CHARS}
          placeholder={`Between ${MIN_POLICY_CHARS}-${MAX_POLICY_CHARS} characters…`}
          className={`${base} ${rpErr ? "border-red-500" : "border-gray-300"}`}
        />
        {rpErr && (
          <p className="text-xs text-red-600 mt-1">{rpErr.message}</p>
        )}
      </div>

      {/* Terms of Sale --------------------------------------------------- */}
      <div>
        <label className="block font-medium">
          Terms of Sale <span className="text-red-500">*</span>
        </label>
        <textarea
          {...register("policies.termsOfSale")}
          rows={4}
          minLength={MIN_POLICY_CHARS}
          maxLength={MAX_POLICY_CHARS}
          placeholder={`Between ${MIN_POLICY_CHARS}-${MAX_POLICY_CHARS} characters…`}
          className={`${base} ${tosErr ? "border-red-500" : "border-gray-300"}`}
        />
        {tosErr && (
          <p className="text-xs text-red-600 mt-1">{tosErr.message}</p>
        )}
      </div>
    </section>
  );
}
